import globalEventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'

let $muteButton = $('button.mute')
let isMute  = false

globalEventBus.on('sound muted', mute)
globalEventBus.on('sound unmuted', unmute)

globalEventBus.on('menu hidden', hideButton)
globalEventBus.on('menu displayed', showButton)


$muteButton.click(function () {
    let muteMessage = 'mute'
    if (isMute) {
        muteMessage = 'unmute'
    }
    globalEventBus.emit('player wants to ' + muteMessage)
})


let fadeDelay = 500
function hideButton () {
    $muteButton.fadeOut(fadeDelay)
}



function showButton () {
    $muteButton.fadeIn(fadeDelay)
}

function mute () {
    isMute = true
    $('.custom_icon.active').removeClass('active')
    $('.custom_icon.icon-mute').addClass('active')
}

function unmute () {
    isMute = false
    $('.custom_icon.active').removeClass('active')
    $('.custom_icon.icon-sound').addClass('active')
}

